<h1 class="primary" mat-dialog-title>
  {{ "operations.select_hierarchy" | transloco }}
</h1>
<div mat-dialog-content style="height: 450px">
  <mat-form-field class="w-100 loren-form-field">
    <mat-label>{{ "operations.search_here" | transloco }}</mat-label>
    <input #search matInput />
  </mat-form-field>
  <loren-hierarchy-selector
    [showCheckboxes]="data.showCheckboxes"
    [showAssets]="data.showAssets"
    [editable]="false"
    [filter]="search.value"
    [selectedGroups]="data.selectedGroups"
    (hierarchySelectionChange)="handleSelectionChange($event)"
  >
  </loren-hierarchy-selector>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="cancel()">
    {{ "operations.cancel" | transloco }}
  </button>
  <button
    mat-stroked-button
    color="primary"
    (click)="save()"
  >
    {{ "operations.save" | transloco }}
  </button>
</div>
